export const environment = {
  production: false,
  apiUrl: 'https://dev.api.agisales.com.br',
  storage: {
    tokenKey: 'auth_token',
    rememberKey: 'remember_me',
    userKey: 'user_data',
  },
  oauth: {
    microsoft: {
      enabled: true,
      authUrl: 'https://dev.api.agisales.com.br/auth/microsoft',
    },
  },
  firebase: {
    apiKey: 'AIzaSyCZilJ91B1_z54_DwNxVo59UCfDhEwpb-U',
    authDomain: 'agisales-7cc3f.firebaseapp.com',
    projectId: 'agisales-7cc3f',
    storageBucket: 'agisales-7cc3f.firebasestorage.app',
    messagingSenderId: '538036289748',
    appId: '1:538036289748:web:1055d2475156f4ae967b41',
    measurementId: 'G-8QNZYH58CM',
  },
  firebaseVapidKey:
    'BLtS9g1uEAgh2u6yJPFynmkWmwnfCQAcVF-c_RRRN_rK1CG6lpATGn2a_LpIl7Q1yj-BryNBycmoNQTTzYvzdRI',
};
